//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import VueHorizontal from 'vue-horizontal'
import { directive } from 'v-aspect-ratio'
import seguroEmpateMixin from '~/mixins/seguro-empate'
const sports = require('~/data/sports.json')
const slugify = require('speakingurl');

export default {
  /*beforeRouteEnter(to, from, next) {
    if (!_.includes(sports, _.get(to, 'params.sport'))) {
      next(false)
    } else {
      next()
    }
  },*/
  directives: {
    'aspect-ratio': directive
  },
  components: { VueHorizontal },
  mixins: [seguroEmpateMixin],
  computed: {
    showBetBuilder() {
      // return false
      return _.get(this.event, 'betbuilder')
    },
    currentMarketGroup() {
      return _.find(this.marketGroups, { value: this.selectedMarketGroup })
    },
    statsURL() {
      let locales = {
        en: 'eng',
        fr: 'fre',
        de: 'ger',
        es: 'spa',
        pt: 'pt-br',
        ja: 'jpn',
        ro: 'rum'
      }

      return 'https://animations.namerandomness.com/#/widget/animation?gameid=' + this.get_event_id(_.get(this.event, 'id')) + '&lang=' + _.get(locales, this.lang, 'eng')
    }
  },
  data() {
    return {
      isTest: false,
      showSportradar: false,
      showStream: false,
      eventId: null,
      stageWidth: null,
      stageHeight: null,
      forceVisible: null,
      marketsLoading: false,
      loading: true,
      event: null,
      originalMarkets: [],
      markets: [],
      outcomes: [],
      selectedMarketGroup: null,
      selectedTab: null,
      video: null,
      sections: [
        { id: '1', competitionId: null, label: 'Preview' },
        { id: '4', competitionId: null, label: 'Statistics' },
        { id: '3', competitionId: null, label: 'Head to Head' }
      ],
      marketGroups: [{ value: null, label: 'A-Z' }],
      crumbs: [],
      showBetBuilderMarkets: false,
      betbuilderCategories: [],
      selectedBetBuilderCategory: 'Popular',
      scrollPosition: 0
    }
  },
  mounted() {
    this.loading = true
    this.eventId = '1-'+this.getEventId(this.$route.params.slug)
    if (tock.active('markets')) {
      tock.clear('markets')
    }
    if (tock.active('stage')) {
      tock.clear('stage')
    }
    this.fetchEvent()

    tock.setInterval(
      'stage',
      () => {
        this.setWidth()
      },
      1000
    )

    emitter.on('*', this.onMatchEventChange)
    this.handleScroll();
    
    if(this.$route.query.test === 'true') {
      if(window.location.href.indexOf("staging") > -1 || window.location.href.indexOf("local") > -1) {
        this.isTest = true
      }
    }
    this._onScroll = _.throttle(() => {
      this.scrollPosition = window.pageYOffset
    }, 100)
    window.addEventListener('scroll', this._onScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this._onScroll)
    tock.clear('markets')
    emitter.off('*', this.onMatchEventChange)
  },
  methods: {
    handleScroll() {
      window.addEventListener("scroll", () => {
        this.scrollNow()
      });
    },
    scrollNow() {
      this.scrollPosition = window.pageYOffset;
    },
    async toggleStream() {
      if(this.isMobile) {
        this.showStream = !this.showStream;
      } else {
          if(!_.get(this.$store.state, 'streamingVideo.id')) {
            this.$store.commit('setStreamingVideo', {'provider': 'imgarena', 'id': _.get(this.event, 'id')})
          } else {
            this.$store.commit('setStreamingVideo', null)
          }
      }
    },
    async toggleTestStream() {
      if(this.isMobile) {
        this.showTestStream = !this.showTestStream;
      } else {
          if(!_.get(this.$store.state, 'streamingVideo.id')) {
            this.$store.commit('setStreamingVideo', {'provider': 'imgarena', 'id': _.get(this.event, 'id')})
          } else {
            this.$store.commit('setStreamingVideo', null)
          }
      }
    },
    async playStream() {
      this.showStream = true;
    },
    async stopStream() {
      this.showStream = false;
    },
    onMatchEventChange(type, e) {
      if (type == 'events') {
        if (_.size(_.intersection(e, [_.get(this.event, 'id')]))) {
          console.log('onMatchEventChange onMatchEventChange', _.get(this.event, 'id'), type, e)
          this.updateEvent()
        }
      }
    },
    selectBetBuilderCategory(category) {
      this.selectedBetBuilderCategory = category
    },
    setBetBuilderCategories(categories) {
      this.betbuilderCategories = categories;
    },
    displayBetBuilder() {
      this.showBetBuilderMarkets = true
    },
    toggleBetBuilder() {
      this.showBetBuilderMarkets = !this.showBetBuilderMarkets
      this.$store.commit('setBetSlipType', this.showBetBuilderMarkets?'betbuilder':null)
      this.selectedBetBuilderCategory = 'Popular'
    },
    openStats() {
      this.$store.commit('setStatId', this.event.id)
      this.$modal.show('modal-stats')
    },
    toggleAll() {
      if (this.forceVisible === null) {
        this.forceVisible = true
      } else if (this.forceVisible === false) {
        this.forceVisible = true
      } else if (this.forceVisible === true) {
        this.forceVisible = false
      }
    },
    selectMarketGroup(marketGroup) {
      console.log('selectMarketGroup', marketGroup)
      this.selectedMarketGroup = marketGroup

      this.markets = []
      this.marketsLoading = true

      //make a request to get markets
      this.updateEvent()
    },
    addToSlip(event, market, outcome) {
      console.log(event, market, outcome)
      this.$store.commit('add', { event: event, market: market, outcome: outcome })
    },
    async setWidth() {
      if (this.$refs.stage) {
        let ratio = 0.4765
        this.stageWidth = this.$refs.stage.clientWidth
        this.stageHeight = this.stageWidth * ratio
      }
    },
    async fetchEvent() {
      try {
        let params = { event_id: this.eventId, bookmaker: process.env.BOOKMAKER, lang: this.lang, country: this.country }
        params.group = 'none'
        const response = await this.$cached().$get('/v1/prematch/markets', { params: params })
        console.log('markets', this.$route.query, response)
        this.event = response
        if(_.get(response, 'sportradar.match_id') && 
       /*This below line whether the match has live tracking, if not it will refer to the old scoreboard*/ 
       !(_.get(this.event, 'sportradar.lmtCoverage') == 1)) {
          this.showSportradar = true
        }
        //this.event.is_live = true
        this.originalMarkets = _.get(response, 'markets')
        this.markets = _.get(response, 'markets')
        this.marketGroups = _.get(response, 'market_groups')
        this.selectMarketGroup(_.get(response, 'default_market'))
        this.loading = false
        this.$store.commit('seo/setVariables', { event: _.get(this.event, 'name'), competition: _.get(this.event, 'competition.name'), sport: _.get(this.event, 'sport.name'), date: _.get(this.event, 'day') })

        let event_slug =  slugify(_.get(this.event, 'name') + '-' + this.getEventId(_.get(this.event, 'id')));
        if(event_slug !== _.get(this.$route.params, 'slug')) {
          //change the url
          let real_path = this.localePath({ name: 'match-screen', params: {
            sport: _.get(this.event, 'translated_sport_slug'),
            slug: slugify(this.event.name) + '-' + this.getEventId(_.get(this.event, 'id')),
            competition: _.get(this.event, 'translated_competition_slug'),
          }})
          history.pushState({},null, real_path);

          var meta_code = document.createElement('meta');
          meta_code.id = "prerender-status-code";
          meta_code.name = "prerender-status-code";
          meta_code.content = "301";
          document.getElementsByTagName('head')[0].appendChild(meta_code);
          
          var meta_header = document.createElement('meta');
          meta_header.id = "prerender-header";
          meta_header.name = "prerender-header";
          meta_header.content = "Location: "+real_path;
          document.getElementsByTagName('head')[0].appendChild(meta_header);

        }

        this.crumbs = [
          { name: _.get(this.event, 'sport.name'), url: this.localePath('/' + _.get(this.event, 'translated_sport_slug')) },
          { name: _.get(this.event, 'region.name') + ' - ' + _.get(this.event, 'competition.name'), url: this.localePath({ name: 'sport-competition', params: { sport: _.get(this.event, 'translated_sport_slug'), competition: _.get(this.event, 'translated_competition_slug') } }) }
        ]

        if (_.get(this.event, 'is_live')) {
          await this.updateEvent()
          await this.showLiveTab(_.get(this.event, 'sport_slug'), _.get(this.event, 'id'))
        }

      } catch (e) {
        console.log(e)
        console.log(e.message)
        this.$nuxt.error({statusCode: 404, message: 'Page not found'})
      }
    },
    async showLiveTab(sport_slug, event_id) {
      this.$store.commit('setHeaderTab', 'live')
      this.$store.commit('setInplayEvent', { sport: sport_slug, event_id: event_id })
    },
    async updateEvent() {
      
      let params = {
        event_id: this.eventId,
        group: this.selectedMarketGroup,
        bookmaker: process.env.BOOKMAKER,
        lang: this.lang,
        country: this.country
      }
      if(this.$config.WEBSOCKET_URL) {
        this.$sportify().sportsbook.getMarkets(params, (response) => {
          this.event = response
          //this.event.is_live = true
          this.originalMarkets = _.get(response, 'markets')
          this.markets = _.get(response, 'markets')
          this.marketGroups = _.get(response, 'market_groups')
          this.loading = false
          this.marketsLoading = false
        })
      } else {
        this.$socket().send('find', 'markets', params, (error, response) => {
          this.event = response
          //this.event.is_live = true
          this.originalMarkets = _.get(response, 'markets')
          this.markets = _.get(response, 'markets')
          this.marketGroups = _.get(response, 'market_groups')
          this.loading = false
          this.marketsLoading = false
        })
      }
    }
  }
}
